<app-grid>
  <div class="col-span-12 dark:border-[#404040] dark:text-white text-sm rounded-l h-full flex flex-col">
  @if(gateways && gateways.length == 0){
    <div class="max-w-sm m-auto mt-16 text-center fle flex-col items-center">
      <h3 class="grow text-primary text-xl font-bold">Register a new Gateway</h3>
      <p>Here you can register or deregister your gateways used for the Almanac Distribution System.
        Gateways allow you to broadcast almanac to update your devices.
        Please contact the support if you want to use this functionality.</p>
      <button
        class="w-52 h-52 border border-dashed border-base-300 rounded m-auto mt-16 flex items-center"
        (click)="openDialogGateway('register')">
        <div class="m-auto">
          <span class="w-full text-primary text-lg">Register new gateway</span>
          <svg class="m-auto mt-4" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="54" height="54" rx="27" fill="#7B35C6"/>
            <path d="M27.0005 21.5835C27.4146 21.5835 27.7503 21.9194 27.7505 22.3335V26.2505H31.6665C32.0807 26.2505 32.4165 26.5863 32.4165 27.0005C32.4165 27.4147 32.0807 27.7505 31.6665 27.7505H27.7505V31.6665C27.7505 32.0807 27.4147 32.4165 27.0005 32.4165C26.5863 32.4165 26.2505 32.0807 26.2505 31.6665V27.7505H22.3335C21.9194 27.7503 21.5835 27.4146 21.5835 27.0005C21.5835 26.5864 21.9194 26.2507 22.3335 26.2505H26.2505V22.3335C26.2507 21.9194 26.5864 21.5835 27.0005 21.5835Z" fill="white"/>
          </svg>
        </div>
      </button>
    </div>
  }
  @if(gateways && gateways.length > 0){
    <div class="flex justify-between max-w-full w-full items-center pb-6 pt-6">
      <div>
        <h3 class="grow text-primary text-xl font-bold dark:text-white">Almanac Distribution System</h3>
        <p>Gateways allow you to broadcast almanac to update your devices.</p>
      </div>
      <div>
        <button
          class="btn btn-primary font-normal"
          (click)="openDialogGateway('register')">
          <span>Register Gateway</span>
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.41699 0C5.8311 0 6.16682 0.335936 6.16699 0.75V4.66699H10.083C10.4972 4.66699 10.833 5.00278 10.833 5.41699C10.833 5.83121 10.4972 6.16699 10.083 6.16699H6.16699V10.083C6.16699 10.4972 5.83121 10.833 5.41699 10.833C5.00278 10.833 4.66699 10.4972 4.66699 10.083V6.16699H0.75C0.335936 6.16682 0 5.8311 0 5.41699C0 5.00289 0.335936 4.66717 0.75 4.66699H4.66699V0.75C4.66717 0.335936 5.00289 0 5.41699 0Z" fill="white"/>
          </svg>

        </button>
      </div>
    </div>
    <div class="overflow-x-auto max-w-full">
      <table class="w-full">
        <thead class="dark:text-white">
        <tr>
          <th class="text-[10px] p-2 font-normal text-left">Gateway id</th>
          <th class="text-[10px] p-2 font-normal text-left">Mode</th>
          <th class="text-[10px] p-2 font-normal text-left">Country code</th>
          <th class="text-[10px] p-2 font-normal text-left">Power</th>
          <th class="text-[10px] p-2 font-normal text-left">Connected</th>
          <th class="w-[160px]"></th>
        </tr>
        </thead>
        <tbody>
          @for (gateway of gateways; track gateway){
            <tr (click)="getGatewayStats(gateway)" [ngClass]="isSelectedGateway(gateway)" class="border-gray-300 dark:border-[#404040] dark:bg-black cursor-pointer">
              <td class="align-top font-mono text-xs p-2 border border-r-0 rounded-l-sm border-gray-300 dark:border-[#404040]">{{gateway.gateway_id}}</td>
              <td class="align-top p-2 text-xs border border-x-0 border-gray-300 dark:border-[#404040]">{{gateway.mode}}</td>
              <td class="align-top p-2 text-xs border border-x-0 border-gray-300 dark:border-[#404040] text-wrap break-all">{{ gateway.country_code }}</td>
              <td class="align-top text-xs p-2 border border-x-0 border-gray-300 dark:border-[#404040] text-wrap break-all">{{ gateway.power }}</td>
              <td class="align-top text-xs p-2 border border-x-0 px-4 border-gray-300 dark:border-[#404040]">
                <span class="relative inline-flex size-3 rounded-full mr-1" [ngClass]="getStatusClass(gateway.state)"></span>
              </td>
              <td class="align-top border border-l-0 px-2 rounded-r-sm border-gray-300 dark:border-[#404040]">
                <div class="actions flex items-center pt-1">
                  <button
                    class="btn btn-ghost btn-xs mx-1"
                    (click)="generateKeyPair(gateway)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-4">
                      <path d="M2.586 17.4139C2.2109 17.7889 2.00011 18.2975 2 18.8279V20.9999C2 21.2651 2.10536 21.5195 2.29289 21.707C2.48043 21.8946 2.73478 21.9999 3 21.9999H6C6.26522 21.9999 6.51957 21.8946 6.70711 21.707C6.89464 21.5195 7 21.2651 7 20.9999V19.9999C7 19.7347 7.10536 19.4803 7.29289 19.2928C7.48043 19.1053 7.73478 18.9999 8 18.9999H9C9.26522 18.9999 9.51957 18.8946 9.70711 18.707C9.89464 18.5195 10 18.2651 10 17.9999V16.9999C10 16.7347 10.1054 16.4803 10.2929 16.2928C10.4804 16.1053 10.7348 15.9999 11 15.9999H11.172C11.7024 15.9998 12.211 15.789 12.586 15.4139L13.4 14.5999C14.7898 15.0841 16.3028 15.0822 17.6915 14.5947C19.0801 14.1071 20.2622 13.1628 21.0444 11.916C21.8265 10.6693 22.1624 9.19409 21.9971 7.73165C21.8318 6.26922 21.1751 4.90617 20.1344 3.86549C19.0937 2.8248 17.7307 2.1681 16.2683 2.00281C14.8058 1.83751 13.3306 2.17341 12.0839 2.95556C10.8372 3.7377 9.89279 4.91979 9.40525 6.30844C8.91771 7.69708 8.91585 9.21008 9.4 10.5999L2.586 17.4139Z" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16.5 8C16.7761 8 17 7.77614 17 7.5C17 7.22386 16.7761 7 16.5 7C16.2239 7 16 7.22386 16 7.5C16 7.77614 16.2239 8 16.5 8Z" fill="#404040" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <button
                    class="btn btn-ghost btn-xs mx-1"
                    (click)="broadCastAlmanacNow(gateway)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-4">
                      <path d="M4.9001 19.0999C1.0001 15.1999 1.0001 8.7999 4.9001 4.8999" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7.79995 16.2C5.49995 13.9 5.49995 10.1 7.79995 7.69995" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16.2 7.80005C18.5 10.1 18.5 13.9 16.2 16.3" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19.1001 4.8999C23.0001 8.7999 23.0001 15.0999 19.1001 18.9999" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <button
                    class="btn btn-ghost btn-xs mx-1"
                    (click)="openDialogGateway('update',gateway)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-4">
                      <path d="M21.174 6.81189C21.7027 6.28332 21.9998 5.56636 21.9999 4.81875C22 4.07113 21.7031 3.3541 21.1745 2.82539C20.6459 2.29668 19.929 1.99961 19.1813 1.99951C18.4337 1.99942 17.7167 2.29632 17.188 2.82489L3.842 16.1739C3.60981 16.4054 3.43811 16.6904 3.342 17.0039L2.021 21.3559C1.99515 21.4424 1.9932 21.5342 2.01535 21.6217C2.03749 21.7092 2.08292 21.7891 2.14679 21.8529C2.21067 21.9167 2.29062 21.962 2.37815 21.984C2.46569 22.006 2.55755 22.0039 2.644 21.9779L6.997 20.6579C7.31017 20.5626 7.59517 20.392 7.827 20.1609L21.174 6.81189Z" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <button
                    class="btn btn-ghost btn-xs mr-1"
                    (click)="confirmDelete(gateway)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-4">
                      <path d="M3 6H21" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10 11V17" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14 11V17" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>

              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if(selectedGateway){
      <div class="flex items-center pb-6 mt-12">
        <h3 class="text-primary text-xl font-bold mr-8 dark:text-white">Gateway stats</h3>
        <p>{{'Latest stats for ' + selectedGateway.gateway_id}}</p>
      </div>
      @if (gatewayStats && gatewayStats.length > 0){
        <div class="overflow-x-auto max-w-full">
        <table class="w-full">
          <thead class="dark:text-white">
          <tr>
            <th class="text-[10px] p-2 font-normal text-left">Received at</th>
            <th class="text-[10px] p-2 font-normal text-left">Metadata</th>
          </tr>
          </thead>
          <tbody>
            @for (stat of gatewayStats; track stat){
              <tr class="border-gray-300 dark:border-[#404040] cursor-pointer bg-white dark:bg-black dark:text-white">
                <td class="align-top text-xs p-2 border border-r-0 rounded-l-sm border-gray-300 dark:border-[#404040]">
                  <div class="text-nowrap">{{dateTimeUtils.extractDate(stat.received_at) }}</div>
                  <div>{{dateTimeUtils.extractTime(stat.received_at) }}</div>
                </td>
                <td class="align-top border border-l-0 p-2 text-xs font-mono rounded-r-sm border-gray-300 dark:border-[#404040]">{{stat.stats.metadata | json}}</td>
              </tr>
            }
          </tbody>
        </table>
        </div>
      } @else {
        <p>No messages</p>
      }
    }
  }
  </div>
</app-grid>
